import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['toggle', 'buttons']

  on() {
    this.buttonsTarget.classList.add('share-links--fade')
    this.toggleTarget.style.display = 'none'
  }

  off() {
    this.buttonsTarget.classList.remove('share-links--fade')
    this.toggleTarget.style.display = 'block'
  }
}
